export type IntervalValue = 'monthly' | 'weekly' | 'daily';

export enum StatType {
  gmv = 'gmv',
  cancelledGmv = 'cancelled_gmv',
  soldLots = 'sold_lots',
  lotsInAuction = 'lots_in_auction',
  sellRate = 'sell_rate',
  averageLotValue = 'average_lot_value',
}
